module.exports = {
    getWidth: function (breakpoint) {
        let width = getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${breakpoint}`);

        return parseInt(width);
    },
    isUpTo: function (bp) {
        const width = getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${bp}`);
        return width !== '' && window.matchMedia(`(min-width: ${width})`).matches;
    },
    isDownTo: function (bp) {
        const width = getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-${bp}`);
        return width !== '' && window.matchMedia(`(max-width: ${width})`).matches;
    }
}